import React from "react"
import { Button } from "reactstrap"
import PropTypes from "prop-types"
import DeleteModal from "components/Common/DeleteModal"
import EditClientModal from "./EditClientModal"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import useDisclosure from "hooks/useDisclosure"
import useParamsQuery from "hooks/useParamsQuery"
import { toast } from "react-toastify"
import { deleteClient } from "api/clientApi"
import { checkValue } from "helpers/utils"
import moment from "moment"

function ClientRow({ clientData }) {
  const {
    id,
    user,
    company,
    package: packageItem,
    created_at,
    credit,
    total_pages,
  } = clientData
  const deleteModal = useDisclosure()
  const editModal = useDisclosure()
  const queryClient = useQueryClient()
  const { params, addParam } = useParamsQuery()

  // delete contract mutation
  const { mutate, isPending } = useMutation({
    mutationFn: deleteClient,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries("clients")
      deleteModal.close()
    },
    onError: error => toast.error(error),
  })

  return (
    <React.Fragment>
      {deleteModal.isOpen ? (
        <DeleteModal
          show={deleteModal.isOpen}
          onCloseClick={deleteModal.close}
          onDeleteClick={() => mutate(id)}
          isLoading={isPending}
        />
      ) : null}
      {editModal.isOpen ? (
        <EditClientModal
          isOpen={editModal.isOpen}
          toggle={editModal.toggle}
          clientData={clientData}
        />
      ) : null}
      <tr>
        <td>
          <p className="mb-0">{user.fullname}</p>
          <p className="mb-0">{checkValue(company)}</p>
        </td>
        <td>
          <p className="mb-0">{user.phone}</p>
          <p className="mb-0">{user.email}</p>
        </td>
        <td>{credit}</td>
        <td>{checkValue(packageItem?.name)}</td>
        <td>{total_pages}</td>
        <td>{moment(created_at).format("l LT")}</td>
        <td>
          <div className="d-flex gap-2">
            <Button size="sm" color="soft-success" onClick={editModal.open}>
              <i className="bx bx-pencil"></i>
            </Button>
            <Button size="sm" color="soft-danger" onClick={deleteModal.open}>
              <i className="bx bx-trash"></i>
            </Button>
          </div>
        </td>
      </tr>
    </React.Fragment>
  )
}

ClientRow.propTypes = {
  clientData: PropTypes.object,
}

export default ClientRow
